import { eEstadoMaestro } from "../common/enumModel";
import { ITipoEmpleadoModel } from "../interfaces/tipo-empleado/ITipoEmpleadoModel";

export class TipoEmpleadoModel implements ITipoEmpleadoModel {
    
    idTipoEmpleado : number;
    nombre : string;
    idEstado: eEstadoMaestro;
    estado: string;
    
    constructor(){
        this.idTipoEmpleado = 0;
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.estado = '';
    }
}